((ATCAnimation, $) => {
  'use strict';

  const $dom = {};

  const cacheDom = () => {
    $dom.atcIcon = $('.add-icon');
  }

  const bindUIActions = () => {
    $(document).on('mouseenter', '.upsell-product-atc__wrapper', () => {
      $('.add-icon').addClass('on-hover')
    }).on('mouseleave','.upsell-product-atc__wrapper', () => {
      $('.add-icon').removeClass('on-hover')
    });

    // $(document).on('click', '.upsell-product-atc__wrapper', () =>{
    //   $('.add-icon').addClass('on-hover');
    //   $('.upsell-product__wrapper').addClass('added-to-cart');
    //   $('.circle').addClass('animate');
    // })
  };

  ATCAnimation.init = () => {
    cacheDom();
    bindUIActions();
  }

})(window.ATCAnimation = window.ATCAnimation || {}, jQuery);